import * as React from 'react';
import { RouteComponentProps, Switch } from 'react-router';
import { PrivateRoute } from 'src/router';

import { AgentListController } from './agents/list/agent-list.controller';
import { AgentFormController } from './agents/form/agent-form.controller';

import { PolicyListController } from './policies/list/policy-list.controller';
import { PolicyFormController } from './policies/form/policy-form.controller';

import { QuoteListController } from './quotes/list/quote-list.controller';
import { QuoteFormController } from './quotes/form/quote-form.controller';

import { QuotePolicyListController } from './quote-policies/list/quote-policy-list.controller';
import { QuotePolicyFormController } from './quote-policies/form/quote-policy-form.controller';

import { QuoteProductPolicyListController } from './quote-product-policies/list/quote-product-policy-list.controller';
import { QuoteProductPolicyFormController } from './quote-product-policies/form/quote-product-policy-form.controller';

import { ConfirmationQuoteController } from 'src/app/bookings/confirmation-quotes/confirmation-quote.controller'

import { SellMarginPolicyListController } from 'src/app/bookings/sell-margin-policies/list/sell-margin-policy-list.controller';
import { SellMarginPolicyFormController } from 'src/app/bookings/sell-margin-policies/form/sell-margin-policy-form.controller';

import { QuoteItineraryGroupListController } from './quote-groups/list/quote-group-list.controller';
import { QuoteItineraryGroupFormController } from './quote-groups/form/quote-group-form.controller';

import { QuoteProductVisibilityPolicyListController } from './quote-product-visibility-policies/list/quote-product-visibility-policy-list.controller';
import { QuoteProductVisibilityPolicyFormController } from './quote-product-visibility-policies/form/quote-product-visibility-policy-form.controller';

import * as Permissions from '../permissions';

export class BookingsController extends React.Component<RouteComponentProps<any>, {}> {
	render(): React.ReactNode {
		const { match } = this.props;

		return (
			<Switch>
				<PrivateRoute
					path={`${match.url}/agents/:id`}
					component={AgentFormController}
					permissions={Permissions.agentWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/agents`}
					component={AgentListController}
					permissions={Permissions.agentPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/policies/:id`}
					component={PolicyFormController}
					permissions={Permissions.policyWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/policies`}
					component={PolicyListController}
					permissions={Permissions.policyPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quotes/:id`}
					component={QuoteFormController}
					permissions={Permissions.quoteWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quotes`}
					component={QuoteListController}
					permissions={Permissions.quotePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quote-policies/:id`}
					component={QuotePolicyFormController}
					permissions={Permissions.policyWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quote-policies`}
					component={QuotePolicyListController}
					permissions={Permissions.policyPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quote-product-policies/:id`}
					component={QuoteProductPolicyFormController}
					permissions={Permissions.policyWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quote-product-policies`}
					component={QuoteProductPolicyListController}
					permissions={Permissions.policyPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quote-product-visibility-policies/:id`}
					component={QuoteProductVisibilityPolicyFormController}
					permissions={Permissions.policyWritePermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/quote-product-visibility-policies`}
					component={QuoteProductVisibilityPolicyListController}
					permissions={Permissions.policyPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/confirmation-quotes`}
					component={ConfirmationQuoteController}
					permissions={Permissions.quotePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/sell-margin-policies/:id`}
					component={SellMarginPolicyFormController}
					permissions={Permissions.policyPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/sell-margin-policies`}
					component={SellMarginPolicyListController}
					permissions={Permissions.policyPermissions}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/groups/:id`}
					component={QuoteItineraryGroupFormController}
					permissions={Permissions.quoteGroupPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/groups`}
					component={QuoteItineraryGroupListController}
					permissions={Permissions.quoteGroupPermission}
					{...this.props}
				/>
			</Switch>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/bookings.controller.tsx